import type { Bus } from "./lib/Bus"
import {
  PollCRDT,
  withBallot,
  withCandidate,
  withCandidateDeleted,
  withTitle,
} from "./poll"
import { applyTo as pass, pipe, sort, times } from "ramda"
import { v4 as uuid } from "uuid"
import { sample } from "./lib/random"
import { Faker } from "./lib/faker-lite"

const faker = Faker(123)
const randBool = (a: any, b: any): number =>
  Math.floor(Math.random() * 10) % 2 === 0 ? 1 : -1

const shuffle = (bus: Bus<PollCRDT>) => () => {
  bus.apply(
    pass(
      bus.state.get(),
      pipe(
        withBallot(
          sampleID("agent"),
          sort(randBool, Object.keys(bus.state.get().candidates)),
        ),
      ),
    ),
  )
}

const chaos = (bus: Bus<PollCRDT>) => () => {
  bus.apply(
    pass(
      bus.state.get(),
      pipe(
        withBallot(sampleID("agent"), times(() => sampleID("candidate"))(8)),
        withCandidate({
          id: sampleID("candidate"),
          content: faker.color(),
        }),
        withCandidateDeleted(sampleID("candidate")),
        withTitle(faker.productDescription()),
      ),
    ),
  )
}

type Universe = { [region: string]: string[] }
let universe: Universe = new Proxy(
  {},
  {
    get: function (target: Universe, name: string): any {
      return target.hasOwnProperty(name) ? target[name] : []
    },
  },
)

function sampleID(region: string): string {
  return (
    sample(
      universe[region]!.length < 15
        ? (universe[region] = [...(universe[region] || []), uuid()])
        : universe[region]!,
    ) || "never"
  )
}

export default {
  // @ts-ignore yes it does
  chaos: import.meta.env.MODE === "development" ? chaos : () => {},
  // @ts-ignore yes it does
  shuffle: import.meta.env.MODE === "development" ? shuffle : () => {},
}
